import React, { PureComponent } from "react";
import "./index.css";
import { getStrukturaById } from "../../../src/features/structure/data";
import { Spin } from "antd";
import { FaEye, FaFileDownload } from "react-icons/fa";
import Deputet from "../Deputet";
import { Row, Col } from "reactstrap";

class NewTabs extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      tabs: [true],
      spinning: true
    };
  }

  //  download = (filename, text,URL) => {
  //   var element = document.createElement('a');
  //   element.setAttribute("", 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
  //   element.setAttribute('download', filename);

  //   element.style.display = 'none';
  //   document.body.appendChild(element);

  //   element.click();

  //   document.body.removeChild(element);
  // }

  tabCheck = id => {
    let tabs = this.state.tabs;
    tabs = tabs.map(tab => {
      return false;
    });
    tabs[id] = true;

    this.setState({
      tabs: tabs
    });
  };

  componentDidMount = async () => {
    var a = await getStrukturaById(this.props.match.params.id);
    console.log(a);
    this.setState({ struktura: a, spinning: false });
  };

  render() {
    console.log(this.state);
    const { struktura } = this.state;
    var kaanetar = false;
    var kaanetarIndex = 0;
    if (struktura && struktura.anetaret.length > 0) {
      kaanetar = true;
      kaanetarIndex = 1;
    }
    return (
      <Spin spinning={this.state.spinning} tip="Ne ngarkim..." size="large">
        <div className="tab-container-all">
          <div className="text-wrapper">
            <div className="tittle">{struktura && struktura.emri}</div>
            <div className="text-body">{struktura && struktura.pershkrimi}</div>
          </div>

          <div className="tab-container">
            {kaanetar && (
              <>
                <input
                  type="radio"
                  id="tab0"
                  name="tabGroup2"
                  className="tab-wrapper"
                  checked={this.state.tabs[0]}
                />
                <label
                  onClick={() => {
                    this.tabCheck(0);
                  }}
                  for="tab0"
                >
                  Anetaret
                </label>
              </>
            )}

            {struktura &&
              struktura.kategorite.map((kategori, index) => {
                return (
                  <>
                    <input
                      type="radio"
                      id={"tab" + index + kaanetarIndex}
                      name="tabGroup2"
                      className="tab-wrapper"
                      checked={this.state.tabs[index + kaanetarIndex]}
                    />
                    <label
                      onClick={() => {
                        this.tabCheck(index + kaanetarIndex);
                      }}
                      for={"tab" + index + kaanetarIndex}
                    >
                      {kategori.emri}
                    </label>
                  </>
                );
              })}
            <div className="tab__content">
              <p>
                <Row>
                  {struktura &&
                    struktura.anetaret.map(deputet => {
                      return (
                        <Col
                          className="deputet-anetar"
                          xs="5"
                          sm="5"
                          md="4"
                          lg="2"
                        >
                          <Deputet
                            emri={deputet.emri}
                            vendlindje={deputet.vendlindje}
                            mbiemri={deputet.mbiemri}
                            datelindja={deputet.datelindja}
                          />
                        </Col>
                      );
                    })}
                </Row>
              </p>
            </div>
            {struktura &&
              struktura.kategorite.map(kategoria => {
                return (
                  <div className="tab__content">
                    <p>{kategoria.pershkrimi}</p>
                    {kategoria.dokumenta.map(dokument => {
                      return (
                        <p className="kategori-doc-wrapper">
                          <div className="doc-title">{dokument.emri}</div>
                          <div className="doc-more">
                            <FaEye
                              size={23}
                              className="doc-icon"
                              color={"#38598b"}
                            />
                            <FaFileDownload
                              // onClick={() => {
                              //   this.download()
                              // }}
                              size={23}
                              className="doc-icon"
                              color={"#38598b"}
                            />
                          </div>
                        </p>
                      );
                    })}
                  </div>
                );
              })}
          </div>
        </div>
      </Spin>
    );
  }
}

NewTabs.propTypes = {};

export default NewTabs;
